import { Component, EventEmitter, HostListener, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';

import { assetUrl } from '../../../asset-url';
import { Post, Comment } from '../../../interfaces/post.interface';
import { CollaborationService } from '../../../services/collaboration.service';
import { User } from '../../../interfaces/space.interface';
import { ConfirmationDialogComponent } from '../../../components/confirmation-dialog/confirmation-dialog.component';
import { SharedReusableComponent } from '../shared-reusable/shared-reusable-component.component';
import { SCREEN_TYPES, SharedEvent } from '../../../interfaces/shared.interface';
import { QuillRTEComponent } from '../../../components/quill-rte/quill-rte.component';
import { SharedPostDetailsComponent } from '../shared-post-details/shared-post-details.component';
import { AssetUrlPipe } from '../../../pipes/asset-url.pipe';

@Component({
    selector: 'app-shared-posts',
    templateUrl: './shared-posts.component.html',
    styleUrl: './shared-posts.component.scss',
    imports: [QuillRTEComponent, SharedPostDetailsComponent, AssetUrlPipe]
})
export class SharedPostsComponent extends SharedReusableComponent implements OnInit {
  posts: Post[];
  showPostDetails = false;
  selectedPost: any;
  selectedPostId: any;
  subscribe: boolean = false;
  control: FormControl = new FormControl();
  loggedInUser!: User;
  isFullScreen: boolean = false;
  isUserUnAuthorized = false;
  errorStatusCode;
  displayName = "Posts";
  @Output() downloadAdditionalDocs = new EventEmitter<any>();
  isPostRender: boolean = false;
  screenType: SCREEN_TYPES;

  constructor(public dialog: MatDialog, public sanitizer: DomSanitizer,
    override collaborationService: CollaborationService) {
    super(collaborationService);
  }

  override ngOnInit(): void {
    super.ngOnInit();
  }

  @HostListener('window:beforeunload')
  onWindowClose(): boolean {
    return this.checkIsEditorDataModified();
  }

  checkIsEditorDataModified() {
    const editorDataModified = Object.keys(this.collaborationService.editorDataModified).some(key => this.collaborationService.editorDataModified[key]);
    if (editorDataModified) {
      return false;
    } else {
      return true;
    }
  }

  refreshPosts(ignorePostDetailsView: boolean) {
    const checkIsEditorDataChanged = !this.checkIsEditorDataModified();
    if (checkIsEditorDataChanged) {
      this.dialog.open(ConfirmationDialogComponent, {
        data: {
          title: "Unsaved changes",
          message: "You have made changes to one or more messages that haven't been saved. Are you sure you want to proceed without saving them?",
          buttonText: "ok",
          cancelButtonText: "cancel"
        },
        autoFocus: false,
      }).afterClosed().subscribe((res) => {
        if (res) {
          this.collaborationService.clearRTEData.next(true)
          this.initialize(ignorePostDetailsView);
        }
      });
    } else {
      this.initialize(ignorePostDetailsView);
    }
  }

  override initialize(ignorePostDetailsView = false) {
    // this.showLoader = true;
    this.collaborationService.allPostSpaceDetails = this.sharedData.postsSpace;
    this.posts = this.sharedData.postsSpace.posts.map((post: Post) => this.getPostDataForRendering(post));
    this.loggedInUser = this.sharedData.postsSpace.user;
    this.screenType = this.sharedData.screenType;
  }

  updateAppSubscribeStatus(subscribe: boolean) {
    this.subscribe = subscribe;
  }

  updatePostSpaceLevelSubscription() {

  }

  backToPosts() {
    this.showPostDetails = false;
    this.selectedPost = null;
  }

  trackItemById(index: number, item: Post): any {
    return item.postId; // Assuming items have a unique "postId" property
  }


  postDetailsView(post: Post) {
    this.showPostDetails = true
    this.selectedPost = post
  }

  getPostDataForRendering(post: Post) {
    post.comments = post.comments ?? [];
    post.profilePictureUrl = assetUrl('images/user.svg');

    post.comments.forEach((comment: Comment) => {
      comment.messageToDisplay = this.sanitizer.bypassSecurityTrustHtml(comment.text);
      comment.profilePictureUrl = assetUrl('images/user.svg');
    });

    const numberOfComments = post.comments.length;

    return {
      ...post,
      messageToDisplay: this.sanitizer.bypassSecurityTrustHtml(post.text),
      openCommentBox: numberOfComments > 0,
      numberOfComments,
      comments: post.comments
    };
  }

  async handlePostsRefresh(postsData: Post[]) {
    this.showLoader = true;
    this.posts = await Promise.all(postsData.map(post => this.getPostDataForRendering(post)));
    this.showLoader = false;
  }

  handleFullScreen() {
    this.isFullScreen = !this.isFullScreen;
  }

  notificationSettings() {
    this.collaborationService.setShowOrHideSideNav('notificationDrawer', true);
  }

  override refreshWeavy(): void {
    this.refreshPosts(true);
  }

  handleDetailsActions(event: any) {
    const typedEvent = event as SharedEvent;
    if (typedEvent.action === 'Details') {
      this.postDetailsView(typedEvent.data);
      return;
    }
    this.sharedDataEvent.emit({
      type: this.screenType,
      action: typedEvent.action,
      data: typedEvent.data
    });
  }

  addPost(data: { text: string, id: string }) {
    this.handleDetailsActions({
      action: 'Add Post',
      data
    });
  }

  orderPosts(posts: Post[]) {
    if (!posts || !posts?.length) return posts;
    return posts?.sort((a: Post, b: Post) => new Date(b.modifiedAt).getTime() - new Date(a.modifiedAt).getTime());
  }
}